export const displayOnScreenValueLabel = 'displayOnScreen';
export const displayOnPrintValueLabel = 'displayOnPrint';
export const DISPLAY_SCREEN_PRINT = 'd-none d-print-block d-lg-table-cell';
export const DISPLAY_SCREEN_NO_PRINT = 'd-none d-print-none d-lg-table-cell';
export const DISPLAY_PRINT_NO_SCREEN = 'd-none d-print-block';
export const NO_DISPLAY_SCREEN_PRINT = 'd-none d-print-none';
